import { render, staticRenderFns } from "./SSwitch.vue?vue&type=template&id=6f189d2a&scoped=true"
import script from "./SSwitch.vue?vue&type=script&lang=js"
export * from "./SSwitch.vue?vue&type=script&lang=js"
import style0 from "./SSwitch.vue?vue&type=style&index=0&id=6f189d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f189d2a",
  null
  
)

export default component.exports